// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery__container {
  cursor: grab;
}
.gallery__container .gallery__title {
  position: absolute;
  top: 10vh;
  left: 50px;
}
.gallery__container #image-track {
  display: flex;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(0%, -50%);
  user-select: none;
  /* -- Prevent image highlighting -- */
}
.gallery__container #image-track .imageContainer {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.gallery__container #image-track .imageContainer .imageOver {
  position: absolute;
  width: 35vmin;
  height: 55vmin;
  margin-left: 2vmin;
  margin-right: 2vmin;
  object-fit: cover;
}
.gallery__container #image-track .imageContainer .image {
  width: 35vmin;
  height: 55vmin;
  margin-left: 2vmin;
  margin-right: 2vmin;
  opacity: 1;
  object-fit: cover;
  object-position: 100% center;
  box-shadow: #212121 0px 20px 30px -10px;
  transition: width 0.6s ease, opacity 0.6s ease, margin-left 0.6s ease, margin-right 0.6s ease;
}
.gallery__container #image-track .imageContainer .imageLoading {
  color: white;
  width: 37vmin;
  height: 55vmin;
  margin-left: 2vmin;
  margin-right: 2vmin;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.gallery__container #image-track .imageContainer .imageError {
  font-size: 32px;
  color: firebrick;
  width: 37vmin;
  height: 55vmin;
  margin-left: 2vmin;
  margin-right: 2vmin;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background-color: rgba(255, 255, 255, 0.1);
}
.gallery__container #image-track .imageContainer .imageError .textError {
  color: white;
  margin-top: 10px;
  width: 150px;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 5px;
  opacity: 0.75;
}
.gallery__container #image-track .imageContainer .imageSensible {
  width: 0;
  opacity: 0;
  margin-left: 0;
  margin-right: 0;
}
.gallery__imageDescription {
  width: 100vw;
  position: absolute;
  right: 0;
  bottom: 5vh;
  text-align: center;
  font-size: 13px;
  font-weight: 300;
  letter-spacing: 5px;
}
.gallery__imageDescription .imageDescriptionSeparator {
  opacity: 0.2;
}
.gallery__imageDescription .imageDescriptionInfoOpen {
  opacity: 0.2;
  padding-top: 10px;
  letter-spacing: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Gallery/Gallery.less"],"names":[],"mappings":"AAAA;EAMI,YAAA;AAJJ;AAFA;EAEQ,kBAAA;EACA,SAAA;EACA,UAAA;AAGR;AAPA;EAQQ,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,8BAAA;EACA,iBAAA;EAEN,qCAAqC;AACvC;AAhBA;EAeY,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAIZ;AAvBA;EAqBgB,kBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAKhB;AA/BA;EA6BgB,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,iBAAA;EACA,4BAAA;EACA,uCAAA;EACA,6FAAA;AAKhB;AA1CA;EAwCgB,YAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;AAKhB;AAvDA;EAqDgB,eAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,0CAAA;AAKhB;AAtEA;EAmEoB,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AAMpB;AA/EA;EA6EgB,QAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AAKhB;AACA;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AACJ;AATA;EAUQ,YAAA;AAER;AAZA;EAaQ,YAAA;EACA,iBAAA;EACA,mBAAA;AAER","sourcesContent":[".gallery__container {\n    .gallery__title {\n        position: absolute;\n        top: 10vh;\n        left: 50px;\n    }\n    cursor: grab;\n    #image-track {\n        display: flex;\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(0%, -50%); \n        user-select: none; /* -- Prevent image highlighting -- */\n        .imageContainer {\n            text-align: center;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            .imageOver {\n                position: absolute;\n                width: 35vmin;\n                height: 55vmin;\n                margin-left: 2vmin;\n                margin-right: 2vmin;\n                object-fit: cover;\n            }\n            .image {\n                width: 35vmin;\n                height: 55vmin;\n                margin-left: 2vmin;\n                margin-right: 2vmin;\n                opacity: 1;\n                object-fit: cover;\n                object-position: 100% center;\n                box-shadow: rgb(33, 33, 33) 0px 20px 30px -10px;\n                transition: width .6s ease, opacity .6s ease, margin-left .6s ease, margin-right .6s ease;\n            }\n            .imageLoading {\n                color: white;\n                width: 37vmin;\n                height: 55vmin;\n                margin-left: 2vmin;\n                margin-right: 2vmin;\n                text-align: center;\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: center;\n                border: 1px solid rgba(255,255,255,.2);\n            }\n            .imageError {\n                font-size: 32px;\n                color: firebrick;\n                width: 37vmin;\n                height: 55vmin;\n                margin-left: 2vmin;\n                margin-right: 2vmin;\n                text-align: center;\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: center;\n                border: 1px solid rgba(255,255,255,.2);\n                background-color: rgba(255,255,255,.1);\n                .textError{\n                    color: white;\n                    margin-top: 10px;\n                    width: 150px;\n                    font-size: 12px;\n                    font-weight: 300;\n                    letter-spacing: 5px;\n                    opacity: .75;\n                }\n            }\n            .imageSensible {\n                width: 0;\n                opacity: 0;\n                margin-left: 0;\n                margin-right: 0;\n            }\n        }\n    }\n}\n\n.gallery__imageDescription {\n    width: 100vw;\n    position: absolute;\n    right: 0;\n    bottom: 5vh;\n    text-align: center;\n    font-size: 13px;\n    font-weight: 300;\n    letter-spacing: 5px;\n    .imageDescriptionSeparator {\n        opacity: .2;\n    } \n    .imageDescriptionInfoOpen {\n        opacity: .2;\n        padding-top: 10px;\n        letter-spacing: 2px;\n    } \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
